import React from 'react'
import {FormInstance} from 'antd/es/form'
import {MaskField} from '../MaskField'
import styles from './SortCodeInput.module.scss'

interface SortCodeInputProps {
    placeholder?: string
    disabled?: boolean
    className?: string
    maxLength?: number
    value?: string
    onChange?: (value: string) => void
    form?: FormInstance
    name?: string
    onFieldChange?: (event: {target: {value: string}}) => void
}

export const SortCodeInput: React.FC<SortCodeInputProps> = ({
    placeholder = '__-__-__',
    disabled = false,
    className,
    value,
    onChange,
    onFieldChange
}) => {
    const isMaskOnly = !value || value === ''
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const maskedValue = e.target.value
        const cleanValue = maskedValue.replace(/[^0-9]/g, '')

        if (onChange) {
            onChange(cleanValue)
        }

        if (onFieldChange) {
            onFieldChange({
                target: {
                    value: cleanValue
                }
            })
        }
    }

    const getMaskedValue = (cleanValue: string): string => {
        if (!cleanValue) return ''

        const digits = cleanValue.substring(0, 6)
        if (digits.length <= 2) {
            return digits
        } else if (digits.length <= 4) {
            return `${digits.substring(0, 2)}-${digits.substring(2)}`
        } else {
            return `${digits.substring(0, 2)}-${digits.substring(2, 4)}-${digits.substring(4)}`
        }
    }

    return (
        <MaskField
            mask='99-99-99'
            maskChar='_'
            value={getMaskedValue(value || '')}
            placeholder={placeholder}
            className={`${className || ''} ${styles.maskPlaceholder} ${isMaskOnly ? styles.maskOnly : ''}`}
            disabled={disabled}
            onChange={handleChange}
            formatChars={{
                '9': '[0-9]'
            }}
            alwaysShowMask={true}
        />
    )
}
